/**
 * Utility to filter application routes based on user roles and module permissions.
 * It recursively checks for access rights and feature flags for each route.
 */

import { type TUserRoles } from '../../app/app.constants';
import type { AppRoute } from '../../types/global.types';

export const filterRoutesByRole = (
  routes: AppRoute[],
  role: TUserRoles,
  isEnabled: (moduleId: string, checkFor: 'route' | 'module') => boolean,
  labelFilter = false,
): AppRoute[] => {
  return routes
    .filter((route) => {
      // 1. Role Check
      const hasRole = route.roles.includes(role);
      if (!hasRole || !route.moduleId) return false;
      // if (!hasRole) return false;

      // 2. Module/Feature Check (if moduleId is provided)
      if (route.moduleId && !isEnabled(route.moduleId, 'route')) {
        return false;
      }

      // 3. Label Filter (optional)
      if (labelFilter && !route.label) return false;

      return true;
    })
    .map((route) => ({
      ...route,
      children: route.children
        ? filterRoutesByRole(route.children, role, isEnabled, labelFilter)
        : undefined,
    }))
    .filter(
      (route) => route.element || (route.children && route.children.length > 0),
    );
};
